import { useCachedReferenceLabel } from '@/composition/hosts/chat-object-reference-cache';
import {
  ProjectReplyMessageActions as ProjectReplyMessageActionsView,
  type ProjectReplyMessageActionsProps,
} from '@heidi/agents';

import { stripCiteTags, stripImgTags } from './evidence-subagent/citation-tokens/resolve';
import { ProjectMessageActions } from './ProjectMessageActions';

/** Evidence's citation and image markup, which the copied prose must not carry. */
const stripEvidenceCitationMarkup = (text: string): string =>
  stripImgTags(stripCiteTags(text));

/**
 * Binds a Work reply's action row to the app: the row's Work analytics emit, the
 * reference names the chat-object cache resolved, and Evidence's citation markup.
 */
export const ProjectReplyMessageActions = (props: ProjectReplyMessageActionsProps) => {
  const labelFor = useCachedReferenceLabel();
  return (
    <ProjectReplyMessageActionsView
      {...props}
      MessageActions={ProjectMessageActions}
      labelFor={labelFor}
      stripCitationMarkup={stripEvidenceCitationMarkup}
    />
  );
};
